// Espelha CannedResponse::MAX_ATTACHMENTS (app/models/canned_response.rb).
// Mantenha os dois em sincronia: o backend rejeita com 422 e, como o upload
// acontece antes do submit, cada excedente deixaria um blob órfão.
export const MAX_CANNED_ATTACHMENTS = 5;

export default { MAX_CANNED_ATTACHMENTS };
